import React from 'react';
import { X } from 'lucide-react';
import { colors, fmt } from '../utils/theme';
import { Badge, LoadingSpinner } from './UI';

export default function DetalheXmilesModal({ detalhe, onClose }) {
  const { loading, data, error } = detalhe;
  const x = data?.xmiles;
  const local = data?.local;

  const row = (label, value, color) => value ? (
    <div style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: `1px solid ${colors.border}22` }}>
      <span style={{ fontSize: 12, color: colors.textMuted, fontWeight: 500 }}>{label}</span>
      <span style={{ fontSize: 13, color: color || colors.text, fontWeight: 500, textAlign: 'right', maxWidth: '60%' }}>{value}</span>
    </div>
  ) : null;

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }} onClick={onClose}>
      <div style={{
        background: colors.card, borderRadius: 16, border: `1px solid ${colors.border}`,
        width: '90%', maxWidth: 560, maxHeight: '85vh', overflowY: 'auto', padding: 24,
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>
            Detalhes do Lançamento XMiles
          </h3>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: colors.textMuted, cursor: 'pointer' }}>
            <X size={18} />
          </button>
        </div>

        {loading && (
          <div style={{ textAlign: 'center', padding: 40, color: colors.textDim }}>
            <LoadingSpinner /> Buscando dados no XMiles Manager...
          </div>
        )}

        {error && (
          <div style={{ padding: 16, background: `${colors.danger}22`, borderRadius: 8, color: colors.danger, fontSize: 13 }}>
            Erro ao buscar detalhes: {error}
          </div>
        )}

        {!loading && data && !x && (
          <div>
            {data.message && (
              <div style={{ padding: 12, background: `${colors.warning}22`, borderRadius: 8, color: colors.warning, fontSize: 13, marginBottom: 12 }}>
                {data.message}
              </div>
            )}
            {local && (
              <div>
                {/* Dados principais */}
                <div style={{ background: `${colors.primary}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                    Dados da Transação
                  </div>
                  <div style={{ fontSize: 15, fontWeight: 700, color: colors.text }}>{local.descricao || '-'}</div>
                  <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                    <Badge text={local.origem || 'N/A'} color={local.origem === 'XMILES_PARC' ? '#8b5cf6' : local.origem === 'FATURA_PDF' ? colors.info : colors.textMuted} />
                    {local.parcela && <Badge text={`Parcela ${local.parcela}`} color={colors.primary} />}
                    {local.conciliado ? <Badge text="CONCILIADO" color={colors.success} /> : <Badge text="NÃO CONCILIADO" color={colors.warning} />}
                  </div>
                </div>

                {/* Valores e Datas */}
                <div style={{ marginBottom: 12 }}>
                  {row('Valor', fmt(local.valor), local.valor < 0 ? colors.danger : colors.success)}
                  {row('Categoria', local.categoria)}
                  {row('Data Compra', local.data_compra)}
                  {row('Data Vencimento', local.data_vencimento)}
                  {row('Mês Referência', local.mes_referencia)}
                </div>

                {/* Cartão */}
                <div style={{ background: `${colors.textMuted}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
                  <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                    Cartão
                  </div>
                  {row('Nome do Cartão', local.nome_cartao)}
                  {row('Titular', local.titular_nome)}
                  {local.cartao_id && row('ID Cartão', `#${local.cartao_id}`)}
                </div>

                {/* Observações / IDs XMiles */}
                {local.observacoes && (
                  <div style={{ background: `${colors.info}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
                    <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                      Observações / Referências
                    </div>
                    <div style={{ fontSize: 12, color: colors.text, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                      {local.observacoes}
                    </div>
                  </div>
                )}

                {/* Metadados */}
                <div style={{ fontSize: 11, color: colors.textDim, marginTop: 8 }}>
                  {row('ID Transação', `#${local.id}`)}
                  {row('Criado em', local.created_at)}
                </div>
              </div>
            )}
          </div>
        )}

        {!loading && x && (
          <div>
            {/* Operação Financeira */}
            <div style={{ background: `${colors.primary}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                Operação Financeira
              </div>
              <div style={{ fontSize: 15, fontWeight: 700, color: colors.text }}>{x.operacao || '-'}</div>
              <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
                <Badge text={x.tipo_operacao === 'CR' ? 'CRÉDITO' : 'DÉBITO'}
                  color={x.tipo_operacao === 'CR' ? colors.success : colors.danger} />
                {x.tipo_aplicacao && <Badge text={x.tipo_aplicacao} color={colors.textMuted} />}
              </div>
            </div>

            {/* Classificação */}
            <div style={{ background: `${colors.info}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                Classificação de Despesa
              </div>
              <div style={{ fontSize: 14, fontWeight: 600, color: colors.info }}>{x.tipo_despesa || '-'}</div>
              {x.tipo_transacao && (
                <Badge text={x.tipo_transacao} color={x.tipo_transacao === 'EXPENSE' ? colors.warning : colors.success}
                  style={{ marginTop: 4 }} />
              )}
            </div>

            {/* Dados gerais */}
            <div style={{ marginBottom: 12 }}>
              {row('Descrição', x.descricao)}
              {row('Valor 1ª parcela', fmt(x.valor), colors.warning)}
              {x.valor_outras_parcelas > 0 && row('Valor demais parcelas', fmt(x.valor_outras_parcelas), colors.warning)}
              {row('Nº Parcelas', x.num_parcelas > 1 ? x.num_parcelas : 'À vista')}
              {row('Data Compra', x.data_compra)}
              {row('Data 1º Pagamento', x.data_primeiro_pgto)}
              {row('Status', x.status)}
              {row('Faturamento', x.tipo_faturamento)}
              {row('Responsável', x.responsavel)}
            </div>

            {/* Cartão */}
            <div style={{ background: `${colors.textMuted}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                Cartão
              </div>
              {row('Nome', x.nome_cartao)}
              {row('Bandeira', x.bandeira)}
              {row('Final', x.final_cartao)}
              {row('Tipo', x.tipo_cartao)}
              {row('Titular', x.titular_nome)}
            </div>

            {/* Emissão */}
            {x.emissao_id && (
              <div style={{ background: `${colors.success}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                  Emissão Vinculada
                </div>
                {x._emissao ? (<>
                  {row('Localizador', x._emissao.localizador, colors.success)}
                  {row('Tipo', x._emissao.tipo?.replace(/_/g, ' '))}
                  {row('Status', x._emissao.status)}
                  {row('Segmento', x._emissao.tipo_segmento?.replace(/_/g, ' '))}
                  {row('Data', x._emissao.data)}
                  {x._emissao.data_voo && row('Data Voo', x._emissao.data_voo)}
                  {x._emissao.data_retorno && row('Data Retorno', x._emissao.data_retorno)}
                  {row('Valor Emissão', fmt(x._emissao.valor), colors.warning)}
                  {row('Taxa Embarque', fmt(x._emissao.taxa_embarque), colors.warning)}
                  {x._emissao.taxa_bagagem > 0 && row('Taxa Bagagem', fmt(x._emissao.taxa_bagagem), colors.warning)}
                  {row('Valor Total', fmt(x._emissao.valor_total), colors.warning)}
                  {row('Forma Recebimento', x._emissao.forma_recebimento)}
                  {row('Tipo Emissão', x._emissao.tipo_emissao?.replace(/_/g, ' '))}
                  {x._emissao.conexoes > 0 && row('Conexões', x._emissao.conexoes)}
                  {x._emissao.num_passageiros > 0 && row('Passageiros', x._emissao.num_passageiros)}

                  {/* Programa de milhas */}
                  {x._emissao.programa && (
                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${colors.border}33` }}>
                      <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, marginBottom: 4 }}>PROGRAMA</div>
                      {row('Programa', x._emissao.programa.tipo?.replace(/_/g, ' '), colors.info)}
                      {row('Login', x._emissao.programa.login)}
                      {row('Pontos Usados', x._emissao.programa.pontos_usados?.toLocaleString('pt-BR'))}
                      {x._emissao.programa.custo_medio > 0 && row('Custo Médio (R$/mil)', `R$ ${x._emissao.programa.custo_medio.toFixed(2)}`)}
                    </div>
                  )}

                  {/* Cliente */}
                  {x._emissao.cliente && (
                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${colors.border}33` }}>
                      <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, marginBottom: 4 }}>CLIENTE</div>
                      {row('Nome', x._emissao.cliente.nome)}
                      {row('CPF', x._emissao.cliente.cpf)}
                    </div>
                  )}

                  {/* Passageiros */}
                  {x._emissao.passageiros && x._emissao.passageiros.length > 0 && (
                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${colors.border}33` }}>
                      <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, marginBottom: 4 }}>PASSAGEIROS</div>
                      {x._emissao.passageiros.map((p, i) => row(`Pax ${i+1}`, p.nome))}
                    </div>
                  )}

                  {/* Segmentos */}
                  {x._emissao.segmentos && x._emissao.segmentos.length > 0 && (
                    <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${colors.border}33` }}>
                      <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, marginBottom: 4 }}>TRECHOS</div>
                      {x._emissao.segmentos.map((s, i) => row(`Trecho ${i+1}`, `${s.origem} → ${s.destino} ${s.data || ''} ${s.voo || ''}`))}
                    </div>
                  )}
                </>) : row('ID Emissão', `#${x.emissao_id}`, colors.success)}
              </div>
            )}

            {/* Taxas */}
            {(x.taxa_investidor > 0 || x.taxa_consignacao > 0) && (
              <div style={{ background: `${colors.warning}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                  Taxas
                </div>
                {x.taxa_investidor > 0 && row('Taxa Investidor', fmt(x.taxa_investidor), colors.warning)}
                {x.taxa_consignacao > 0 && row('Taxa Consignação', fmt(x.taxa_consignacao), colors.warning)}
              </div>
            )}

            {/* Parcela específica (se veio de fin-parc) */}
            {x._parc_detail && (
              <div style={{ background: `${colors.primary}11`, borderRadius: 10, padding: 14, marginBottom: 12 }}>
                <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                  Parcela Consultada
                </div>
                {row('Parcela', x._parc_detail.nome)}
                {row('Valor', fmt(x._parc_detail.valor), colors.warning)}
                {row('Vencimento', x._parc_detail.vencimento)}
                {row('Status', x._parc_detail.status)}
              </div>
            )}

            {/* Todas as parcelas */}
            {x.parcelas && x.parcelas.length > 1 && (
              <div style={{ marginTop: 8 }}>
                <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                  Todas as Parcelas ({x.parcelas.length})
                </div>
                <div style={{ maxHeight: 200, overflowY: 'auto', borderRadius: 8, border: `1px solid ${colors.border}` }}>
                  {x.parcelas.map((p, i) => (
                    <div key={p.id || i} style={{
                      display: 'flex', justifyContent: 'space-between', padding: '6px 10px',
                      borderBottom: `1px solid ${colors.border}22`, fontSize: 12,
                    }}>
                      <span style={{ color: colors.textMuted }}>{p.nome}</span>
                      <span style={{ color: colors.textDim }}>{p.vencimento || p.data}</span>
                      <span style={{ color: colors.warning, fontWeight: 600 }}>{fmt(p.valor)}</span>
                      <Badge text={p.status} color={p.status === 'ACTIVE' ? colors.success : colors.textMuted} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Dados locais (transação no sistema) */}
            {local && (
              <div style={{ background: `${colors.textMuted}08`, borderRadius: 10, padding: 14, marginTop: 8, borderTop: `1px solid ${colors.border}33` }}>
                <div style={{ fontSize: 11, color: colors.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 6 }}>
                  Dados Locais (Sistema)
                </div>
                {row('Origem', local.origem)}
                {local.parcela && row('Parcela', local.parcela)}
                {row('Mês Referência', local.mes_referencia)}
                {row('Categoria', local.categoria)}
                {row('ID Transação', `#${local.id}`)}
                {row('Criado em', local.created_at)}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
